var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 m-0 p-0"},[_c('section',{staticClass:"row align-items-stretch h-100 p-0 m-0"},[_c('div',{staticClass:"d-none d-md-block col p-0"},[_c('Form-Welcome')],1),_c('div',{staticClass:"col col-lg-4 m-0",staticStyle:{"background-color":"#494b4d"}},[_c('FormLogin')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }